import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './Map.css';
import './OpenSkiMapView.css';

// 使用环境变量或默认值设置token
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN || 'pk.eyJ1Ijoiemhhb3poZW5oYW8iLCJhIjoiY203OTRzdzFuMDFkODJxcHBxY2JzYzVsYiJ9.F2ogSKhZ9rFkE7v2KcpjIA';

const OpenSkiMapView = () => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    if (map.current) return;

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/outdoors-v12',
      center: [11.4, 47.3], // 阿尔卑斯山区
      zoom: 9,
      minZoom: 3,
      maxZoom: 18
    });

    map.current.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    map.current.addControl(new mapboxgl.ScaleControl());
    map.current.addControl(new mapboxgl.FullscreenControl());

    map.current.on('load', () => {
      setMapLoaded(true);

      // 添加滑雪场数据源
      map.current.addSource('ski-areas', {
        type: 'vector',
        url: 'mapbox://mapbox.mapbox-streets-v8'
      });

      // 添加滑雪场区域图层
      map.current.addLayer({
        'id': 'ski-areas',
        'type': 'fill',
        'source': 'ski-areas',
        'source-layer': 'landuse',
        'filter': ['any',
          ['==', 'type', 'winter_sports'],
          ['==', 'type', 'ski'],
          ['==', 'class', 'winter_sports'],
          ['==', 'class', 'ski']
        ],
        'paint': {
          'fill-color': '#2196F3',
          'fill-opacity': 0.4,
          'fill-outline-color': '#1976D2'
        }
      });

      // 添加滑雪场轮廓
      map.current.addLayer({
        'id': 'ski-areas-outline',
        'type': 'line',
        'source': 'ski-areas',
        'source-layer': 'landuse',
        'filter': ['any',
          ['==', 'type', 'winter_sports'],
          ['==', 'type', 'ski'],
          ['==', 'class', 'winter_sports'],
          ['==', 'class', 'ski']
        ],
        'paint': {
          'line-color': '#1976D2',
          'line-width': 2
        }
      });

      // 添加滑雪场POI标记
      map.current.addLayer({
        'id': 'ski-poi',
        'type': 'symbol',
        'source': 'ski-areas',
        'source-layer': 'poi_label',
        'filter': ['any',
          ['==', 'type', 'ski'],
          ['==', 'type', 'winter_sports']
        ],
        'layout': {
          'icon-image': 'mountain',
          'icon-size': 1.2,
          'text-field': ['get', 'name'],
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12,
          'text-offset': [0, 1.2],
          'text-anchor': 'top'
        },
        'paint': {
          'text-color': '#333',
          'text-halo-color': '#fff',
          'text-halo-width': 1
        }
      });

      // 点击事件处理
      map.current.on('click', 'ski-areas', (e) => {
        if (!e.features.length) return;

        const feature = e.features[0];
        const coordinates = e.lngLat;
        
        new mapboxgl.Popup()
          .setLngLat(coordinates)
          .setHTML(`
            <div class="ski-area-popup">
              <h3>滑雪场</h3>
              <p>类型: ${feature.properties.type || '冬季运动'}</p>
              <p>坐标: ${coordinates.lng.toFixed(4)}, ${coordinates.lat.toFixed(4)}</p>
            </div>
          `)
          .addTo(map.current);
      });

      // 鼠标悬停效果
      map.current.on('mouseenter', 'ski-areas', () => {
        map.current.getCanvas().style.cursor = 'pointer';
      });

      map.current.on('mouseleave', 'ski-areas', () => {
        map.current.getCanvas().style.cursor = '';
      });

      // 添加图例
      const legend = document.createElement('div');
      legend.className = 'map-legend';
      legend.innerHTML = `
        <h4>图例</h4>
        <div class="legend-item">
          <div class="legend-color" style="background: #2196F3"></div>
          <span>滑雪场区域</span>
        </div>
      `;
      map.current.getContainer().appendChild(legend);
    });

    return () => {
      if (map.current) {
        map.current.remove();
        map.current = null;
      }
    };
  }, []);

  return (
    <div className="map-view">
      <div ref={mapContainer} className="map-container" />
      <div className="bottom-right-info">
        <div className="info-container">
          <span className="data-source">
            数据来源: OpenStreetMap
          </span>
          <a 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="icp-link"
          >
            京ICP备2025103740号
          </a>
        </div>
      </div>
    </div>
  );
};

export default OpenSkiMapView; 